var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 3.33333C6.66669 2.59695 7.26364 2 8.00002 2C8.7364 2 9.33335 2.59695 9.33335 3.33333C10.8935 4.07104 11.9191 5.6095 12 7.33333V9.33333C12.1018 10.1739 12.5966 10.9161 13.3334 11.3333H2.66669C3.40343 10.9161 3.89828 10.1739 4.00002 9.33333V7.33333C4.08093 5.6095 5.10657 4.07104 6.66669 3.33333",
    stroke: "#414042",
    strokeWidth: 1.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3359V12.0026C6 13.1072 6.89543 14.0026 8 14.0026C9.10457 14.0026 10 13.1072 10 12.0026V11.3359",
    stroke: "#414042",
    strokeWidth: 1.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.89d029b91df710e0a5dd3069bbe67bf9.svg";
export { ForwardRef as ReactComponent };